<template>
  <a-date-picker
    :allow-clear="true"
    :auto-focus="!screenIsMobile && options.autofocus"
    :default-value="momentObj"
    :disabled="disabled"
    :format="dateTimeFormat"
    :placeholder="options.placeholder"
    :show-time="{ format: dateTimeTimeFormat }"
    :title="field.identifier"
    style="width: 100%"
    :value="momentObj"
    @change="setValue"
  />
</template>

<script>
import Field from '@/components/fields/Field'
import moment from 'moment-timezone'

export default {
  name: 'FieldDateTime',
  extends: Field,
  computed: {
    momentObj () {
      const momentObj = moment.utc(this.value, this.defaultDateAndTimeFormats.dateTime.store)
      if (this.out_value && momentObj.isValid()) {
        return momentObj.tz(moment.tz.guess())
      }
      return null
    },
    dateTimeFormat () {
      return this.field && this.options.date_time_format ? this.options.date_time_format : this.defaultDateAndTimeFormats.dateTime.view
    },
    dateTimeTimeFormat () {
      return this.field && this.options.date_time_format ? this.options.date_time_format : this.defaultDateAndTimeFormats.dateTime.timeView
    },
  },
  methods: {
    setValue (value) {
      if (value) {
        this.out_value = value.utc().format(this.defaultDateAndTimeFormats.dateTime.store)
      }
    },
  },
}
</script>

<style scoped>

</style>
